


























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { formatDateToRussian, getDateUTC } from '../helpers/date-helpers';
import Axios from 'axios';

@Component({})
export default class DateSelectorComponent extends Vue {
	@Prop({ required: true, type: String }) public page: 'world' | 'russia' | 'russiaResort';
	@Prop({ required: false, type: Boolean }) public disabled?: boolean;
	public dateDialog = false;
	public date: string | null = null;
	public dataLoading = false;

	public created() {
		const date = this.$store.getters[`${this.page}/getDataDate`];
		if (typeof date === 'string') {
			this.date = date.substr(0, 10);
		}
	}

	public get getDataDate() {
		return this.$store.getters[`${this.page}/getDataDate`];
	}

	public get allowedDates() {
		return (this.$store.getters[`${this.page}/getAllowedDates`] as string[])
			.map((v) => v.substr(0, 10));
	}

	@Watch('getDataDate')
	private onGetDataDateChange() {
		this.date = this.getDataDate.substr(0, 10);
	}

	@Watch('date')
	private onDateChange(val, oldVal) {
		if (oldVal !== null && val !== oldVal) {
			this.dataLoading = true;
			Axios.get(`/api/${this.page}/day?date=${getDateUTC(this.date!).toJSON()}`)
				.then((r) => this.page !== 'russiaResort' ?
					this.$store.dispatch(`${this.page}/updateSummary`, r.data.dayInfo) :
					this.$store.dispatch(`${this.page}/updateDayInfo`, r.data.dayInfo))
				.then(() => this.dataLoading = false);
		}
	}



	private get computedDateFormatted() {
		return formatDateToRussian(this.date);
	}
	private validateDate(val: string) {
		return this.allowedDates.includes(val);
	}
}
